import { createContext, Dispatch, MouseEvent, SetStateAction } from 'react';

export type ContextMenu = { mouseX: number; mouseY: number };

export type MenuContextValues = {
  anchorEl: HTMLElement | null;
  contextMenu?: ContextMenu;
  onClose: () => void;
  onOpen: (event: MouseEvent<HTMLElement>) => void;
  open: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
};

const MenuContext = createContext<MenuContextValues>({
  anchorEl: null,
  onClose: () => true,
  onOpen: () => true,
  open: false,
  setOpen: () => void 0,
});

export default MenuContext;
